export const SUCCESSFUL_GET_MYPAYMENTS  = "SUCCESSFUL_GET_MYPAYMENTS";


// WEBPACK FOOTER //
// ./src/reducers/mypayments/actionConst.js